
<div
  class="max-w-screen-xl p-6 mx-auto shadow-lg animate-slide-in-left bg-white/80 backdrop-blur-md rounded-xl">
  <app-datatable [data]="certificatControls" [columns]="columns"
    dataType="Gestion des Rapports d'Inspection"
    boutonDataType="Certificat d'inspection"
    routeNavigate="inspecter" [currentPage]="currentPage"
    [totalPages]="totalPages" [totalElements]="totalItems" (pageChange)="onPageChange($event)"></app-datatable>
</div>
